//The user session is the user's logged in data.
// the session is empty if the user is not logged in
// this data also exists in localStorage

import { PrepareApiProcedure } from "../../components/common/utils/prepare-api-procedure";
import { fetchDataFromAPI } from "../../services/api-requests";
import { notificationService } from "../../services/notification-service";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { throwIfEmpty } from "rxjs";
import { UserInfo } from "../../models/user-info";
import { userActions } from "../slices/user-slice";
import { chargerActions } from "../slices/charger-slice";
import { UserSessionAttributes, createUserSession } from "../../models/user-session-model";
import { AppDispatch, RootState } from "..";
import { getDriverPlan, getHostPlan } from "./user-actions";
import { storeUserSession } from "../../services/helpers/session-helpers";


export const setSession = (sessionObj: UserSessionAttributes) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        try {
            const current = getState().user.session;
            const incomingUserId = sessionObj.id;
            const currentUserId = current?.id;
            const isDifferentUser =
                !!incomingUserId &&
                !!currentUserId &&
                incomingUserId !== currentUserId;

            if (isDifferentUser) {
                dispatch(userActions.clearUserObj());
            }

            // Merge only for the same signed-in user so fields like service are
            // not carried over from a previous account after logout/login.
            const merged: UserSessionAttributes = createUserSession(
                !current || isDifferentUser
                    ? sessionObj
                    : { ...current, ...sessionObj }
            );
            dispatch(userActions.setUserSession({ session: merged }));

            // Persist to AsyncStorage so rehydration retains full fields
            try { await storeUserSession(merged); } catch {}

            // update the driver plan
            dispatch(getDriverPlan());

            // update the host plan (used to determine free-tier status)
            dispatch(getHostPlan());
        } catch (error) {
            console.error(error);
        }
    }   
}

export const clearSession = (userSession: UserSessionAttributes | undefined) => {
    return async (dispatch: AppDispatch) => {
        if (userSession === undefined) {
            return;
        }
        try {
            const apiQuery = PrepareApiProcedure("logout", "POST", 'logout', {
                username: userSession.username,
                IpAddress: userSession.IpAddress,
            });
            const loggedOut = await fetchDataFromAPI(apiQuery);
            console.log(loggedOut);
        } catch (error) {
            console.error(error);
        } finally {
            await AsyncStorage.clear();
            dispatch(userActions.setUserSession({ session: undefined }));
            dispatch(userActions.clearUserObj());
            dispatch(userActions.clearActiveCharges());
            dispatch(chargerActions.clearAllChargers());
        }
    };
};